export const VOICE_TYPE = 'VOICE';
export const FIELDS_MAPPER = Object.freeze({
  HOURS: {
    path: 'officeHours',
    defaultValue: {
      timezone: 'America/New_York',
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: [],
    },
  },

  TIMEZONE: {
    path: 'officeHours.timezone',
    defaultValue: 'America/New_York',
  },

  VOICE_CONCURRENCY: {
    path: 'content.concurrency',
    defaultValue: '30',
  },

  VOICE_IVR_NODE: {
    path: 'content.ivrId',
    defaultValue: '',
  },

  VOICE_ENDPOINT_ID: {
    path: 'content.endpointId',
    defaultValue: '',
  },
});
